import './CardSkeleton.scss'

import { Card } from 'react-bootstrap'
import cn from 'classnames'

/**
 * Empty Card Skeleton component. Used to display skeleton cards while loading
 */
export default function CardSkeleton({ className }) {
  return <Card className={cn('card-skeleton', className)}></Card>
}
